import request from './request.js';
import Servers from '@config'

export default {
  // 订单列表
  fetchOrderList: request.get(Servers.oss + '/mall/order/list'),

  // 订单详情
  fetchOrderDetail: request.get(Servers.oss + '/mall/order/detail'),

  // 设置转账信息
  saveOrderTransfer: request.post(Servers.oss + '/mall/order/set-transfer'),

  // 订单发票详情
  fetchInvoice: request.get(Servers.oss + '/mall/invoice/get'),

  // 激活订单
  editOrderActivate: request.post(Servers.oss + '/mall/order/activate'),

  // 提交发票信息
  saveInvoice: request.post(Servers.oss + '/mall/invoice/add'),

  // 取消订单
  cancelOrder: request.post(Servers.oss + '/mall/order/cancel'),

  getActiveQrcode: request.get(Servers.oss + '/mall/order/get-active-qrcode'),

  // 获取可升级站点
  getUpgradableSites: request.get(Servers.oss + '/mall/order/upgradable-sites'),

  // A100升级
  shopUpgrade: request.post(Servers.oss + '/mall/order/shop-upgrade'),
}
